import api from '../lib/api';

const appendIfPresent = (formData, key, value) => {
  if (value !== undefined && value !== null && value !== '') {
    formData.append(key, value);
  }
};

const getApiOrigin = () => {
  const uploadsBaseUrl = process.env.REACT_APP_R2_PUBLIC_URL;
  return uploadsBaseUrl;
};

const normalizeImageUrl = (value) => {
  if (!value) {
    return value;
  }

  if (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('blob:') ||
    value.startsWith('data:')
  ) {
    return value;
  }

  const baseOrigin = getApiOrigin();
  const normalizedPath = value.startsWith('/') ? value : `/${value}`;

  return `${baseOrigin}${normalizedPath}`;
};

const mapInspectionImages = (inspection) => {
  if (!inspection) {
    return inspection;
  }

  return {
    ...inspection,
    images: (inspection.images || []).map((image) => ({
      ...image,
      url: normalizeImageUrl(image.url),
    })),
  };
};

const buildInspectionFormData = (values) => {
  const formData = new FormData();

  appendIfPresent(formData, 'vinNumber', values.vinNumber?.toUpperCase());
  appendIfPresent(formData, 'remarks', values.remarks);

  if (values.frontImageFile) {
    formData.append('frontImage', values.frontImageFile);
  }
  if (values.leftImageFile) {
    formData.append('leftImage', values.leftImageFile);
  }
  if (values.rightImageFile) {
    formData.append('rightImage', values.rightImageFile);
  }
  if (values.backImageFile) {
    formData.append('backImage', values.backImageFile);
  }

  const extraMediaFiles = values.extraMediaFiles || values.extraImageFiles || [];
  extraMediaFiles.forEach((file) => {
    formData.append('extraImages', file);
  });

  if (values.removeExtraImageKeys?.length) {
    formData.append(
      'removeExtraImageKeys',
      JSON.stringify(values.removeExtraImageKeys),
    );
  }

  if (values.retainExtraImageKeys?.length) {
    formData.append(
      'retainExtraImageKeys',
      JSON.stringify(values.retainExtraImageKeys),
    );
  }

  return formData;
};

const inspectionApi = {
  getList: async (filters) => {
    const { data } = await api.get('/vehicle-inspections', { params: filters });
    return {
      ...data,
      data: (data.data || []).map(mapInspectionImages),
    };
  },
  getDetail: async (uuid) => {
    const { data } = await api.get(`/vehicle-inspections/${uuid}`);
    return {
      ...data,
      data: mapInspectionImages(data.data),
    };
  },
  getStats: async () => {
    const { data } = await api.get('/vehicle-inspections/dashboard/stats');
    return data;
  },
  getMonthFolders: async (year) => {
    const { data } = await api.get(
      '/vehicle-inspections/dashboard/month-folders',
      {
        params: { year },
      },
    );
    return data;
  },
  create: async (values) => {
    const { data } = await api.post(
      '/vehicle-inspections',
      buildInspectionFormData(values),
    );
    return data;
  },
  update: async ({ uuid, values }) => {
    const { data } = await api.patch(
      `/vehicle-inspections/${uuid}`,
      buildInspectionFormData(values),
    );
    return data;
  },
  remove: async (uuid) => {
    const { data } = await api.delete(`/vehicle-inspections/${uuid}`);
    return data;
  },
};

export default inspectionApi;
